import { Box, TextField, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import IranFlag from "../../../../../../../media/images/iran_flag.png";
const ProvincePlace = styled(Box)(({ theme }) => ({
  backgroundColor: "#FFD54F",
  ...theme.typography.body2,
  display: "flex",
  flexDirection: "column",
  borderLeft: "2px",
  borderRight: "0px",
  borderTop: "0px",
  borderBottom: "0px",
  borderStyle: "solid",
  borderColor: "#000",
  textAlign: "center",
  paddingBottom: "12px",
  paddingLeft: "8px",
  paddingRight: "8px",
  color: theme.palette.text.secondary,
  height: "70px",
}));

const ContentPlace = styled(Box)(({ theme }) => ({
  backgroundColor: "#FFD54F",
  ...theme.typography.body2,
  display: "flex",
  gap: "4px",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  paddingTop: "14px",
  paddingBottom: "10px",
  paddingLeft: "8px",
  paddingRight: "8px",
  height: "70px",

  color: theme.palette.text.secondary,
}));

const FlagPlace = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  ...theme.typography.body2,

  display: "flex",
  flexDirection: "column",
  textAlign: "center",
  paddingTop: "14px",
  paddingBottom: "15px",
  paddingLeft: "4px",
  paddingRight: "4px",
  height: "70px",
  color: theme.palette.text.secondary,
}));

interface Props {
  licensePlateSerial?: string;
  firstTowDigits?: string;
  alpha?: string;
  lastThiredDigits?: string;
}

export default function PelakInput(props: Props) {
  return (
    <Box
      sx={{
        marginTop: "16px",
        border: "1px solid gray",
        borderRadius: "10px",
        overflow: "hidden",
        maxWidth: "80%",
        marginX: "auto",
      }}
    >
      <Grid container>
        <Grid item xs={2.5}>
          <ProvincePlace>
            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: "700",
              }}
            >
              ایران
            </Typography>
            <TextField
              value={props.licensePlateSerial}
              placeholder="--"
              size="small"
              sx={{
                borderRadius: "8px",

                backgroundColor: "background.default",

                flex: 1,
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none !important",
                  outline: "none !important",
                },
                "& .MuiInputBase-input": {
                  textAlign: "center",

                  border: "none !important",
                  outline: "none !important",
                  paddingLeft: "3px",
                  paddingRight: "3px",
                },
                "& .MuiInputBase-root": {
                  border: "none !important",
                  outline: "none !important",
                },
                border: "1px solid gray",
              }}
            />
          </ProvincePlace>
        </Grid>

        <Grid item xs={8}>
          <ContentPlace>
            <TextField
              value={props.lastThiredDigits}
              placeholder="---"
              size="small"
              sx={{
                borderRadius: "8px",

                backgroundColor: "background.default",

                flex: 1,
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none !important",
                  outline: "none !important",
                },
                "& .MuiInputBase-input": {
                  textAlign: "center",

                  border: "none !important",
                  outline: "none !important",
                },
                "& .MuiInputBase-root": {
                  border: "none !important",
                  outline: "none !important",
                },
                border: "1px solid gray",
              }}
            />
            <Box
              sx={{
                flex: "1",
                display: "flex",
                gap: "4px",
              }}
            >
              {/* <Select
                placeholder="ب"
                sx={{
                  backgroundColor: "background.default",
                  flex: "1",
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none !important",
                    outline: "none !important",
                  },
                  "& .MuiInputBase-input": {
                    border: "none !important",
                    outline: "none !important",
                    fontWeight: "600",
                  },
                  "& .MuiInputBase-root": {
                    border: "none !important",
                    outline: "none !important",
                  },
                  "& .MuiSelect-select": {
                    paddingRight: "3px !important",
                  },
                  "& .MuiSvgIcon-root": {
                    position: "static !important",
                    left: "16px",
                    marginLeft: "10px",
                    // height: "48px !important",
                  },
                  width: "32px",
                  // height: "48px",
                  overflow: "hidden",
                  borderRadius: "8px",
                  border: "1px solid gray",
                }}
                size="small"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                //   value={value?.toString()}
                // label="Age"
                //   onChange={onChange}
              >
                {options.map((item) => (
                  <MenuItem disabled={item.disabled} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select> */}
              <TextField
                value={props.alpha}
                placeholder="-"
                size="small"
                sx={{
                  borderRadius: "8px",

                  backgroundColor: "background.default",

                  flex: 1,
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none !important",
                    outline: "none !important",
                  },
                  "& .MuiInputBase-input": {
                    textAlign: "center",

                    border: "none !important",
                    outline: "none !important",
                    paddingLeft: "3px",
                    paddingRight: "3px",
                  },
                  "& .MuiInputBase-root": {
                    border: "none !important",
                    outline: "none !important",
                  },
                  border: "1px solid gray",
                }}
              />
              <TextField
                value={props.firstTowDigits}
                placeholder="--"
                size="small"
                sx={{
                  borderRadius: "8px",

                  backgroundColor: "background.default",

                  flex: 1,
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none !important",
                    outline: "none !important",
                  },
                  "& .MuiInputBase-input": {
                    textAlign: "center",

                    border: "none !important",
                    outline: "none !important",
                    paddingLeft: "3px",
                    paddingRight: "3px",
                  },
                  "& .MuiInputBase-root": {
                    border: "none !important",
                    outline: "none !important",
                  },
                  border: "1px solid gray",
                }}
              />
            </Box>
          </ContentPlace>
        </Grid>
        <Grid item xs={1.5}>
          <FlagPlace>
            <img
              style={{
                borderRadius: "3px",
              }}
              src={IranFlag}
              alt=""
            />
            <Typography
              sx={{
                fontWeight: "600",
                color: "#fff",
              }}
            >
              IR
            </Typography>
          </FlagPlace>
        </Grid>
      </Grid>
    </Box>
  );
}
